import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";

/**
 * Раздел ролей целиком: и список, и редактор прав. Навешивается на роут, а не
 * внутри страницы, — редактор до рендера тянет имя роли через useSuspenseQuery,
 * и внутри страницы гард не успел бы остановить этот запрос.
 */
export function RestrictRoles({ children }: { children: ReactNode }) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.AdminAccessRoles]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}
